import { AxiosError } from "axios";
import dayjs from "dayjs";
import { GetObraChecklistServicoLiberacaoByIdRequest, GetObraChecklistServicoLiberacaoByIdResponse } from "../daos/read/get_obra_checklist_servico_liberacao_by_id";
import { SaveObraChecklistServicoLiberacaoRequest } from "../daos/update/save_obra_checklist_servico_liberacao";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { GetEmpreendimentoDropDownRequest, GetEmpreendimentoDropDownResponse } from "../daos/read/get_empreendimento_drop_down";
import { IObrasService } from "./obras_service";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { GetObraByIdRequest, GetObraByIdResponse } from "../daos/read/get_obra_by_id";
import { getAllObraRequest, getAllObraResponse } from "../daos/read/get_all_obra";
import { GetEmpreendimentoByIdObraRequest, GetEmpreendimentoByIdObraResponse } from "../daos/read/get_empreendimento_by_id_obra";
import { GetIncorporacaoBlocoDropDownRequest, GetIncorporacaoBlocoDropDownResponse } from "../daos/read/get_incorporacao_bloco_drop_down";
import {
  GetIncorporacaoBlocosByIdListaRequest,
  GetIncorporacaoBlocosByIdListaResponse,
} from "../daos/read/get_incorporacao_blocos_by_id_lista";
import { CreateObraRequest, CreateObraResponse } from "../daos/create/create_obra";
import { UpdateObraRequest, UpdateObraResponse } from "../daos/update/update_obra";
import { DeleteObraRequest, DeleteObraResponse } from "../daos/delete/delete_obra";
import { CopyObraRequest, CopyObraResponse } from "../daos/create/copy_obra";
import {
  CreateObraEstruturaOrganizacionalRequest,
  CreateObraEstruturaOrganizacionalResponse,
} from "../daos/create/create_obra_estrutura_organizacional";
import {
  DeleteObraEstruturaOrganizacionalRequest,
  DeleteObraEstruturaOrganizacionalResponse,
} from "../daos/delete/delete_obra_estrutura_organizacional";
import {
  GetAllObraEstruturaOrganizacionalRequest,
  GetAllObraEstruturaOrganizacionalResponse,
} from "../daos/read/get_all_obra_estrutura_organizacional";
import {
  UpdateObraEstruturaOrganizacionalRequest,
  UpdateObraEstruturaOrganizacionalResponse,
} from "../daos/update/update_obra_estrutura_organizacional";
import {
  GetObraEstruturaOrganizacionalFuncionarioDropDownRequest,
  GetObraEstruturaOrganizacionalFuncionarioDropDownResponse,
} from "../daos/read/get_obra_estrutura_organizacional_funcionario_drop_down";
import { CreateAtividadeObraRequest, CreateAtividadeObraResponse } from "../daos/create/create_atividade_obra";
import { DeleteAtividadeObraRequest, DeleteAtividadeObraResponse } from "../daos/delete/delete_atividade_obra";
import { GetAllAtividadeObraRequest, GetAllAtividadeObraResponse } from "../daos/read/get_all_atividade_obra";
import { UpdateAtividadeObraRequest, UpdateAtividadeObraResponse } from "../daos/update/update_atividade_obra";
import {
  GetAtividadeObraResponsavelDropDownRequest,
  GetAtividadeObraResponsavelDropDownResponse,
} from "../daos/read/get_atividade_obra_responsavel_drop_down";
import {
  GetAtividadeObraCorresponsavelDropDownRequest,
  GetAtividadeObraCorresponsavelDropDownResponse,
} from "../daos/read/get_atividade_obra_corresponsavel_drop_down";
import { GetAllEspecificidadeObraRequest, GetAllEspecificidadeObraResponse } from "../daos/read/get_all_especificidade_obra";
import { CreateEspecificidadeObraRequest, CreateEspecificidadeObraResponse } from "../daos/create/create_especificidade_obra";
import { UpdateEspecificidadeObraRequest, UpdateEspecificidadeObraResponse } from "../daos/update/update_especificidade_obra";
import { DeleteEspecificidadeObraRequest, DeleteEspecificidadeObraResponse } from "../daos/delete/delete_especificidade_obra";
import { CreateIndicadorObraRequest, CreateIndicadorObraResponse } from "../daos/create/create_indicador_obra";
import { DeleteIndicadorObraRequest, DeleteIndicadorObraResponse } from "../daos/delete/delete_indicador_obra";
import { GetAllIndicadorObraRequest, GetAllIndicadorObraResponse } from "../daos/read/get_all_indicador_obra";
import { GetIndicadorDropDownRequest, GetIndicadorDropDownResponse } from "../daos/read/get_indicador_drop_down";
import { CreateObraArquivoRequest, CreateObraArquivoResponse } from "../daos/create/create_obra_arquivo";
import { DeleteObraArquivoRequest, DeleteObraArquivoResponse } from "../daos/delete/delete_obra_arquivo";
import { GetAllObraArquivoRequest, GetAllObraArquivoResponse } from "../daos/read/get_all_obra_arquivo";
import { UpdateObraArquivoRequest, UpdateObraArquivoResponse } from "../daos/update/update_obra_arquivo";
import { CreateObraInformacoesRequest, CreateObraInformacoesResponse } from "../daos/create/create_obra_informacoes";
import { DeleteObraInformacoesRequest, DeleteObraInformacoesResponse } from "../daos/delete/delete_obra_informacoes";
import { GetAllObraInformacoesRequest, GetAllObraInformacoesResponse } from "../daos/read/get_all_obra_informacoes";
import { UpdateObraInformacoesRequest, UpdateObraInformacoesResponse } from "../daos/update/update_obra_informacoes";
import { GetMapaConcretagemFiltroRequest, GetMapaConcretagemFiltroResponse } from "../daos/read/get_mapa_concretagem_filtro";
import { SaveMapaConcretagemFiltroRequest, SaveMapaConcretagemFiltroResponse } from "../daos/update/save_mapa_concretagem_filtro";
import { GetObraAreaDropDownRequest, GetObraAreaDropDownResponse } from "../daos/read/get_obra_area_drop_down";
import { GetObraServicoDropDownRequest, GetObraServicoDropDownResponse } from "../daos/read/get_obra_servico_drop_down";
import { SendEmailRequest, SendEmailResponse } from "../daos/create/send_email";
import { GetAllMapaConcretagemRequest, GetAllMapaConcretagemResponse } from "../daos/read/get_all_mapa_concretagem";
import { GetMapaConcretagemByIdRequest, GetMapaConcretagemByIdResponse } from "../daos/read/get_mapa_concretagem_by_id";
import { CreateMapaConcretagemRequest, CreateMapaConcretagemResponse } from "../daos/create/create_mapa_concretagem";
import { UpdateMapaConcretagemRequest, UpdateMapaConcretagemResponse } from "../daos/update/update_mapa_concretagem";
import { DeleteMapaConcretagemRequest, DeleteMapaConcretagemResponse } from "../daos/delete/delete_mapa_concretagem";
import { CopyMapaConcretagemRequest, CopyMapaConcretagemResponse } from "../daos/create/copy_mapa_concretagem";
import { GetObraHeaderInfoRequest, GetObraHeaderInfoResponse } from "../daos/read/get_obra_header_info";
import {
  GetMonitoramentoChecklistEmpresaDropDownRequest,
  GetMonitoramentoChecklistEmpresaDropDownResponse,
} from "../daos/read/get_monitoramento_checklist_empresa_drop_down";
import {
  GetMonitoramentoChecklistFuncionarioDropDownRequest,
  GetMonitoramentoChecklistFuncionarioDropDownResponse,
} from "../daos/read/get_monitoramento_checklist_funcionario_drop_down";
import { GetAllObraAreaChecklistRequest, GetAllObraAreaChecklistResponse } from "../daos/read/get_all_obra_area_checklist";
import {
  GetObraChecklistServicosDropDownRequest,
  GetObraChecklistServicosDropDownResponse,
} from "../daos/read/get_obra_checklist_servicos_drop_down";
import { CreateObraAreaChecklistRequest, CreateObraAreaChecklistResponse } from "../daos/create/create_obra_area_checklist";
import { CreateObraAreaEmpreendimentoChecklistRequest, CreateObraAreaEmpreendimentoChecklistResponse } from "../daos/create/create_obra_area_empreendimento_checklist";
import { UpdateObraAreaChecklistRequest, UpdateObraAreaChecklistResponse } from "../daos/update/update_obra_area_checklist";
import { DeleteObraAreaChecklistRequest, DeleteObraAreaChecklistResponse } from "../daos/delete/delete_obra_area_checklist";
import { GetStatInformationByIdObraRequest, GetStatInformationByIdObraResponse } from "../daos/read/get_stat_information_by_id_obra";
import { DeleteLoteObraAreaChecklistRequest, DeleteLoteObraAreaChecklistResponse } from "../daos/delete/delete_lote_obra_area_checklist";
import { GetObraAreaChecklistDropDownRequest, GetObraAreaChecklistDropDownResponse } from "../daos/read/get_obra_area_checklist_drop_down";
import { CreateAreaChecklistServicosRequest, CreateAreaChecklistServicosResponse } from "../daos/create/create_area_checklist_servicos";
import { DeleteAreaChecklistServicosRequest, DeleteAreaChecklistServicosResponse } from "../daos/delete/delete_area_checklist_servicos";
import { CopyObraAreaChecklistRequest, CopyObraAreaChecklistResponse } from "../daos/create/copy_obra_area_checklist";
import {
  GetAllObraEstruturaTreinamentosRequest,
  GetAllObraEstruturaTreinamentosResponse,
} from "../daos/read/get_all_obra_estrutura_treinamentos";
import { CreateObrasPlanoTreinamentoRequest, CreateObraTreinamentoResponse } from "../daos/create/create_obras_plano_treinamento";
import { DeletePlanoTreinamentoObraResponse, DeletePlanoTreinamentoRequest } from "../daos/delete/delete_plano_treinamento_obra";
import { UpdatePlanoTreinamentoObraRequest, UpdatePlanoTreinamentoObraResponse } from "../daos/update/update_plano_treinamento_obra";
import {
  CreateObraAlvenariaEstruturalResponse,
  CreateObrasAlvenariaEstruturalRequest,
} from "../daos/create/create_obras_alvenaria_estrutural";
import {
  GetAllObraAlvenariaEstruturalRequest,
  GetAllObraAlvenariaEstruturalResponse,
} from "../daos/read/get_all_obra_alvenaria_estrutural";
import { UpdateAlvenariaEstrutualObraRequest, UpdateAlvenariaEstrutualObraResponse } from "../daos/update/update_alvenaria_estrutural_obra";
import { DeleteAlvenariaEstruturalRequest, DeleteAlvenariaEstruturalResponse } from "../daos/delete/delete_alvenaria_estrutural";
import {
  GetAllObrasGestaoDeResiduosRequest,
  GetAllObrasGestaoDeResiduosResponse,
  GetByidObrasGestaoDeResiduosResponse,
} from "../daos/read/get_all_obras_gestao_de_residuos";
import { UpdateObrasGestaoDeResiduosRequest } from "../daos/update/update_obras_gestao_de_residuos";
import { CreateObrasGestaoDeResiduosRequest } from "../daos/create/create_obras_gestao_de_residuos";
import { GetAllControleMateriaisRequest, GetAllControleMateriaisResponse } from "../daos/read/get_all_controle_materiais";
import { CreateControleMateriaisRequest } from "../daos/create/create_controle_materiais";
import { GetControleMateriaisByIdResponse } from "../daos/read/get_controle_materiais_by_id";
import { UpdateControleMateriaisRequest } from "../daos/update/update_controle_materiais";
import { GetAllControleServicosRequest, GetAllControleServicosResponse } from "../daos/read/get_all_controle_servicos";
import { CreateControleServicosRequest } from "../daos/create/create_controle_servicos";
import { GetControleServicosByIdResponse } from "../daos/read/get_controle_servicos_by_id";
import { UpdateControleServicosRequest } from "../daos/update/update_controle_servicos";
import { GetObraAreaChecklistHeaderRequest, GetObraAreaChecklistHeaderResponse } from "../daos/read/get_obra_area_checklist_header";
import { GetAllObraChecklistServicoRequest, GetAllObraChecklistServicoResponse } from "../daos/read/get_all_obra_checklist_servico";
import {
  GetAllObrasMateriaisControladosRequest,
  GetAllObrasMateriaisControladosResponse,
} from "../daos/read/get_all_obras_materiais_controlados_list";
import { CreateObraMateriaisControladosRequest } from "../daos/create/create_obra_materiais_controlados";
import {
  GetAllObrasServicosControladosRequest,
  GetAllObrasServicosControladosResponse,
} from "../daos/read/get_all_obras_servicos_controlados_list";
import { CreateObraServicosControladosRequest } from "../daos/create/create_obra_servicos_controlados";
import { GetObraMateriaisControladosDropDown } from "../daos/read/get_obra_materiais_controlados_dropdown";
import { GetObraServicosControladosDropDown } from "../daos/read/get_obra_servicos_controlados_dropdown";
import { GetChecklistServicosDropDownRequest, GetChecklistServicosDropDownResponse } from "../daos/read/get_checklist_servicos_drop_down";
import { CreateObraChecklistServicosRequest, CreateObraChecklistServicosResponse } from "../daos/create/create_checklist_servicos";
import { DeleteObraChecklistServicosRequest, DeleteObraChecklistServicosResponse } from "../daos/delete/delete_obra_checklist_servicos";
import {
  GetObraChecklistServicoHeaderRequest,
  GetObraChecklistServicoHeaderResponse,
} from "../daos/read/get_obra_checklist_servico_header";
import { GetAllInspecaoObraRequest, GetAllInspecaoObraResponse } from "../daos/read/get_all_inspecao_obra";
import {
  GetObraChecklistServicoStatisticasRequest,
  GetObraChecklistServicoStatisticasResponse,
} from "../daos/read/get_obra_checklist_servico_statisticas";
import {
  UpdateStatusObraChecklistServicoRequest,
  UpdateStatusObraChecklistServicoResponse,
} from "../daos/update/update_obra_checklist_servico";
import {
  UpdateMetaObraChecklistServicoRequest,
  UpdateMetaObraChecklistServicoResponse,
} from "../daos/update/update_meta_obra_checklist_servico";
import {
  UpdateInspecaoObraAprovacaoLoteRequest,
  UpdateInspecaoObraAprovacaoLoteResponse,
} from "../daos/update/update_inspecao_obra_aprovacao_lote";
import {
  GetObraChecklistServicoCamposRequest,
  GetObraChecklistServicoCamposResponse,
} from "../daos/read/get_obra_checklist_servico_campos";
import { CreateInspecaoObraRequest, CreateInspecaoObraResponse } from "../daos/create/create_inspecao_obra";
import { DeleteInspecaoObraRequest, DeleteInspecaoObraResponse } from "../daos/delete/delete_inspecao_obra";
import { UpdateInspecaoObraRequest, UpdateInspecaoObraResponse } from "../daos/update/update_inspecao_obra";
import { CopyInspecaoObraRequest, CopyInspecaoObraResponse } from "../daos/create/copy_inspecao_obra";
import { GetInspecaoObraByIdRequest, GetInspecaoObraByIdResponse } from "../daos/read/get_inspecao_obra_by_id";
import { GetAllInspecaoObraItemRequest, GetAllInspecaoObraItemResponse } from "../daos/read/get_all_inspecao_obra_item";
import { GetAllExecutadoPorRequest, GetAllExecutadoPorResponse } from "../daos/read/get_all_executado_por";
import { GetAllInspecaoObraOcorrenciaRequest, GetAllInspecaoObraOcorrenciaResponse } from "../daos/read/get_all_inspecao_obra_ocorrencia";
import { CreateInspecaoObraOcorrenciaRequest, CreateInspecaoObraOcorrenciaResponse } from "../daos/create/create_inspecao_obra_ocorrencia";
import { UpdateInspecaoObraOcorrenciaRequest, UpdateInspecaoObraOcorrenciaResponse } from "../daos/update/update_inspecao_obra_ocorrencia";
import { DeleteInspecaoObraOcorrenciaRequest, DeleteInspecaoObraOcorrenciaResponse } from "../daos/delete/delete_inspecao_obra_ocorrencia";
import { GetAllAtributosObrasCadastroResponse } from "../daos/read/get_all_atributos_obras_cadastro";
import { UpdateAtributosObrasCadastroRequest } from "../daos/update/update_atributos_obras_cadastro";
import {
  CreateInspecaoObraExecutadoPorRequest,
  CreateInspecaoObraExecutadoPorResponse,
} from "../daos/create/create_inspecao_obra_executado_por";
import {
  DeleteInspecaoObraExecutadoPorRequest,
  DeleteInspecaoObraExecutadoPorResponse,
} from "../daos/delete/delete_inspecao_obra_executado_por";
import {
  UpdateInspecaoObraWithValidationRequest,
  UpdateInspecaoObraWithValidationResponse,
} from "../daos/update/update_inspecao_obra_with_validation";
import { GetInspecaoObraImageRequest } from "../daos/read/get_inspecao_obra_image";
import { GetAllChecklistServicoRequest, GetAllChecklistServicoResponse } from "../daos/read/get_all_checklist_servico";
import { CreateChecklistServicoRequest, CreateChecklistServicoResponse } from "../daos/create/create_checklist_servico";
import { UpdateChecklistServicoRequest, UpdateChecklistServicoResponse } from "../daos/update/update_checklist_servico";
import { DeleteChecklistServicoRequest, DeleteChecklistServicoResponse } from "../daos/delete/delete_checklist_servico";
import { CopyChecklistServicoRequest, CopyChecklistServicoResponse } from "../daos/create/copy_checklist_servico";
import { GetChecklistServicoByIdRequest, GetChecklistServicoByIdResponse } from "../daos/read/get_checklist_servico_by_id";
import { GetAllItemChecklistServicoRequest, GetAllItemChecklistServicoResponse } from "../daos/read/get_all_item_checklist_servico";
import { CreateItemChecklistServicoRequest, CreateItemChecklistServicoResponse } from "../daos/create/create_item_checklist_servico";
import { UpdateItemChecklistServicoRequest, UpdateItemChecklistServicoResponse } from "../daos/update/update_item_checklist_servico";
import { DeleteItemChecklistServicoRequest, DeleteItemChecklistServicoResponse } from "../daos/delete/delete_item_checklist_servico";
import {
  GetEstatisticasChecklistServicoRequest,
  GetEstatisticasChecklistServicoResponse,
} from "../daos/read/get_estatisticas_checklist_servico";
import { CreateControleAguaRequest, CreateControleAguaResponse } from "../daos/create/create_controle_agua";
import { CreateControleEnergiaRequest, CreateControleEnergiaResponse } from "../daos/create/create_controle_energia";
import { CreateControleResiduoRequest, CreateControleResiduoResponse } from "../daos/create/create_controle_residuo";
import { DeleteControleAguaRequest, DeleteControleAguaResponse } from "../daos/delete/delete_controle_agua";
import { DeleteControleEnergiaRequest, DeleteControleEnergiaResponse } from "../daos/delete/delete_controle_energia";
import { DeleteControleResiduoRequest, DeleteControleResiduoResponse } from "../daos/delete/delete_controle_residuo";
import { GetAllControleAguaRequest, GetAllControleAguaResponse } from "../daos/read/get_all_controle_agua";
import { GetAllControleEnergiaRequest, GetAllControleEnergiaResponse } from "../daos/read/get_all_controle_energia";
import { GetAllControleResiduoRequest, GetAllControleResiduoResponse } from "../daos/read/get_all_controle_residuo";
import { GetControleAguaByIdRequest, GetControleAguaByIdResponse } from "../daos/read/get_controle_agua_by_id";
import { GetControleEnergiaByIdRequest, GetControleEnergiaByIdResponse } from "../daos/read/get_controle_energia_by_id";
import { GetControleResiduoByIdRequest, GetControleResiduoByIdResponse } from "../daos/read/get_controle_residuo_by_id";
import { UpdateControleAguaRequest, UpdateControleAguaResponse } from "../daos/update/update_controle_agua";
import { UpdateControleEnergiaRequest, UpdateControleEnergiaResponse } from "../daos/update/update_controle_energia";
import { UpdateControleResiduoRequest, UpdateControleResiduoResponse } from "../daos/update/update_controle_residuo";
import { DownloadObraDocumentoRequest } from "../daos/read/download_obra_documento";
import { GetAllManutencaoEquipObraRequest, GetAllManutencaoEquipObraResponse } from "../daos/read/get_all_manutencao_quip_obra";
import { GetManutencaoEquipObraByIdRequest, GetManutencaoEquipObraByIdResponse } from "../daos/read/get_manutenco_equip_obra_by_id";
import { CreateManutencaoEquipObraRequest, CreateManutencaoEquipObraResponse } from "../daos/create/create_manutencao_quip_obra";
import { UpdateManutencaoEquipObraRequest, UpdateManutencaoEquipObraResponse } from "../daos/update/update_manutencao_quip_obra";
import { GetDashboardObrasInformationRequest, GetDashboardObrasInformationResponse } from "../daos/read/get_dashboard_obras_information";
import { GetRestricoesPainelObraRequest, GetRestricoesPainelObraResponse } from "../daos/read/get_restricoes_painel_obra";
import { DeleteSelectedItemChecklistServicoRequest, DeleteSelectedItemChecklistServicoResponse } from "../daos/delete/delete_selected_checklist_servico";
import { DownloadMateriaisControladosByIdRequest } from "../daos/read/download_materiais_controlados_by_id";
import { AprovacaoFinalMapaConcretagemRequest, AprovacaoFinalMapaConcretagemResponse } from "../daos/update/aprovacao_final_mapa_concretagem";
import { GetIndicadoresServicosObrasRequest, GetIndicadoresServicosObrasResponse } from "../daos/read/get_indicadores_servicos_obras";
import { GetChecklistServicosByIdObraDropDownRequest, GetChecklistServicosByIdObraDropDownResponse } from "../daos/read/get_checklist_servicos_by_id_obra_drop_down";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { DownloadAlvenariaEstruturaRequest } from "../daos/read/download_alvenaria_estrutura";
import { GetChecklistServicoAmbienteByIdRequest, GetChecklistServicoAmbienteByIdResponse } from "../daos/read/get_checklist_servico_ambiente_by_id";
import { GetAllChecklistServicoAmbienteRequest, GetAllChecklistServicoAmbienteResponse } from "../daos/read/get_all_checklist_servico_ambiente";
import { CreateChecklistServicoAmbienteRequest, CreateChecklistServicoAmbienteResponse } from "../daos/create/create_checklist_servico_ambiente";
import { UpdateChecklistServicoAmbienteRequest, UpdateChecklistServicoAmbienteResponse } from "../daos/update/update_checklist_servico_ambiente";
import { CopyChecklistServicoAmbienteRequest, CopyChecklistServicoAmbienteResponse } from "../daos/create/copy_checklist_servico_ambiente";
import { DownloadEquipamentoMedicaoArquivoRequest } from "../daos/read/download_equipamento_medicao_arquivo";
import { DownloadMapaConcretagemArquivoRequest } from "../daos/read/download_mapa_concretagem_arquivo";
import { GetReinspecaoEmAbertoListaRequest, GetReinspecaoEmAbertoListaResponse } from "../daos/read/get_reinspecao_em_aberto";
import { UpdateIndicadorObraRequest, UpdateIndicadorObraResponse } from "../daos/update/update_indicador_obra";
import { CreateChecklistServicoLiberacaoRequest, CreateChecklistServicoLiberacaoResponse } from "../daos/create/create_checklist_servico_liberacao";
import { DeleteChecklistServicoLiberacaoRequest, DeleteChecklistServicoLiberacaoResponse } from "../daos/delete/delete_checklist_servico_liberacao";
import { GetAllChecklistServicoLiberacaoRequest, GetAllChecklistServicoLiberacaoResponse } from "../daos/read/get_all_checklist_servico_liberacao";
import { GetChecklistServicoLiberacaoByIdRequest, GetChecklistServicoLiberacaoByIdResponse } from "../daos/read/get_checklist_servico_liberacao_by_id";
import { UpdateChecklistServicoLiberacaoRequest, UpdateChecklistServicoLiberacaoResponse } from "../daos/update/update_checklist_servico_liberacao";

/**
 * ObrasService
 */

export class ObrasService implements IObrasService {

  async getEmpreendimentoDropdown(request: GetEmpreendimentoDropDownRequest): Promise<GetEmpreendimentoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/empreendimentos/dropdown`, request);
      const response = handleAxiosResponse<GetEmpreendimentoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getIncorporacaoBlocoDropdown(request: GetIncorporacaoBlocoDropDownRequest): Promise<GetIncorporacaoBlocoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/empreendimentos/${request.idEmpreendimento}/blocos/dropdown`);
      const response = handleAxiosResponse<GetIncorporacaoBlocoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraEstruturaOrganizacionalFuncionarioDropDown(
    request: GetObraEstruturaOrganizacionalFuncionarioDropDownRequest,
  ): Promise<GetObraEstruturaOrganizacionalFuncionarioDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/estruturas-organizacionais/funcionarios/dropdown`);
      const response = handleAxiosResponse<GetObraEstruturaOrganizacionalFuncionarioDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAtividadeObraResponsavelDropDown(
    request: GetAtividadeObraResponsavelDropDownRequest,
  ): Promise<GetAtividadeObraResponsavelDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/atividades-obra/responsavel/dropdown/${request.idFuncionarioResponsavel ?? ""}`);
      const response = handleAxiosResponse<GetAtividadeObraResponsavelDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAtividadeObraCorresponsavelDropDown(
    request: GetAtividadeObraCorresponsavelDropDownRequest,
  ): Promise<GetAtividadeObraCorresponsavelDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/obras/atividades-obra/corresponsavel/dropdown/${request.idFuncionarioCorresponsavel ?? ""}`,
      );
      const response = handleAxiosResponse<GetAtividadeObraResponsavelDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getIndicadorDropDown(request: GetIndicadorDropDownRequest): Promise<GetIndicadorDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/indicadores/dropdown/${request.idObra}`);
      const response = handleAxiosResponse<GetIndicadorDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraAreaDropDown(request: GetObraAreaDropDownRequest): Promise<GetObraAreaDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area/dropdown`, request);
      const response = handleAxiosResponse<GetObraAreaDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraServicoDropDown(request: GetObraServicoDropDownRequest): Promise<GetObraServicoDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/servico/dropdown`, request);
      const response = handleAxiosResponse<GetObraServicoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMonitoramentoChecklistEmpresaDropDown(
    request: GetMonitoramentoChecklistEmpresaDropDownRequest,
  ): Promise<GetMonitoramentoChecklistEmpresaDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/monitoramento-checklist/empresa/${request.idObra}/dropdown`);
      const response = handleAxiosResponse<GetMonitoramentoChecklistEmpresaDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMonitoramentoChecklistFuncionarioDropDown(
    request: GetMonitoramentoChecklistFuncionarioDropDownRequest,
  ): Promise<GetMonitoramentoChecklistFuncionarioDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/monitoramento-checklist/funcionario/${request.idObra}/dropdown`);
      const response = handleAxiosResponse<GetMonitoramentoChecklistFuncionarioDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraChecklistServicosDropDown(
    request: GetObraChecklistServicosDropDownRequest,
  ): Promise<GetObraChecklistServicosDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklist/checklist-servicos/${request.idObra}/dropdown`, {
        ...request,
        idObra: undefined,
      });
      const response = handleAxiosResponse<GetObraChecklistServicosDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraAreaChecklistDropDown(request: GetObraAreaChecklistDropDownRequest): Promise<GetObraAreaChecklistDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklist/${request.idObra}/dropdown`, { ...request, idObra: undefined });
      const response = handleAxiosResponse<GetObraAreaChecklistDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getChecklistServicosDropDown(request: GetChecklistServicosDropDownRequest): Promise<GetChecklistServicosDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/checklist-servico/dropdown`);
      const response = handleAxiosResponse<GetChecklistServicosDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraById({ idObra, ...request }: GetObraByIdRequest): Promise<GetObraByIdResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/${idObra}`, request);
      const response = handleAxiosResponse<GetObraByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllObra(request: getAllObraRequest): Promise<getAllObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras`, request);
      const response = handleAxiosResponse<getAllObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getEmpreendimentoByIdObra(request: GetEmpreendimentoByIdObraRequest): Promise<GetEmpreendimentoByIdObraResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/${request.idObra}/empreendimentos`);
      const response = handleAxiosResponse<GetEmpreendimentoByIdObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getIncorporacaoBlocosByIdLista(request: GetIncorporacaoBlocosByIdListaRequest): Promise<GetIncorporacaoBlocosByIdListaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/empreendimentos/blocos`, request);
      const response = handleAxiosResponse<GetIncorporacaoBlocosByIdListaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createObra(request: CreateObraRequest): Promise<CreateObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/create`, request);
      const response = handleAxiosResponse<CreateObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateObra(request: UpdateObraRequest): Promise<UpdateObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/update`, request);
      const response = handleAxiosResponse<CreateObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObra({ idObra, ...request }: DeleteObraRequest): Promise<DeleteObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/${idObra}/delete`, request);
      const response = handleAxiosResponse<DeleteObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyObra(request: CopyObraRequest): Promise<CopyObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/copy`, request);
      const response = handleAxiosResponse<CopyObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createObraEstruturaOrganizacional(
    request: CreateObraEstruturaOrganizacionalRequest,
  ): Promise<CreateObraEstruturaOrganizacionalResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/estruturas-organizacionais/create`, request);
      const response = handleAxiosResponse<CreateObraEstruturaOrganizacionalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateObraEstruturaOrganizacional(
    request: UpdateObraEstruturaOrganizacionalRequest,
  ): Promise<UpdateObraEstruturaOrganizacionalResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/estruturas-organizacionais/update`, request);
      const response = handleAxiosResponse<UpdateObraEstruturaOrganizacionalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObraEstruturaOrganizacional(
    request: DeleteObraEstruturaOrganizacionalRequest,
  ): Promise<DeleteObraEstruturaOrganizacionalResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/estruturas-organizacionais/delete/${request.idEstruturaOrganizacional}`);
      const response = handleAxiosResponse<DeleteObraEstruturaOrganizacionalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllObraEstruturaOrganizacional(
    request: GetAllObraEstruturaOrganizacionalRequest,
  ): Promise<GetAllObraEstruturaOrganizacionalResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/estruturas-organizacionais`, request);
      const response = handleAxiosResponse<GetAllObraEstruturaOrganizacionalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region  Plano Treinamento

  async getAllObraEstruturaTreinamento(request: GetAllObraEstruturaTreinamentosRequest): Promise<GetAllObraEstruturaTreinamentosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/plano-treinamento/listTreinameto`, request);
      const response = handleAxiosResponse<GetAllObraEstruturaTreinamentosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createObraPlanoTreinamento(request: CreateObrasPlanoTreinamentoRequest): Promise<CreateObraTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/plano-treinamento/create`, request);
      const response = handleAxiosResponse<CreateObraTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObraPlanoTreinamento(request: DeletePlanoTreinamentoRequest): Promise<DeletePlanoTreinamentoObraResponse> {
    try {
      const result = await axiosInstance({}).delete("/obras/plano-treinamento/delete", { data: request });
      const response = handleAxiosResponse<DeletePlanoTreinamentoObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateObraPlanoTreinamento(request: UpdatePlanoTreinamentoObraRequest): Promise<UpdatePlanoTreinamentoObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/plano-treinamento/update`, request);
      const response = handleAxiosResponse<UpdatePlanoTreinamentoObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region AlvenariaEstrutural

  async createAlvenariaEstrutural(request: CreateObrasAlvenariaEstruturalRequest): Promise<CreateObraAlvenariaEstruturalResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/obras/alvenaria-estrutura/create`, formData, options);
      const response = handleAxiosResponse<CreateObraAlvenariaEstruturalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllObrasAlvenariaEstrutural(request: GetAllObraAlvenariaEstruturalRequest): Promise<GetAllObraAlvenariaEstruturalResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/alvenaria-estrutura/listAlvenariaEstrutura`, request);
      const response = handleAxiosResponse<GetAllObraAlvenariaEstruturalResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAlvenariaEstrutural(request: UpdateAlvenariaEstrutualObraRequest): Promise<UpdateAlvenariaEstrutualObraResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/obras/alvenaria-estrutura/updateAlvenariaEstrutura`, formData, options);
      const response = handleAxiosResponse<UpdateAlvenariaEstrutualObraResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteObraAlvenariaEstrutural(request: DeleteAlvenariaEstruturalRequest): Promise<DeleteAlvenariaEstruturalResponse> {
    try {
      const result = await axiosInstance({}).delete("/obras/alvenaria-estrutura/delete", { data: request });
      const response = handleAxiosResponse<DeleteAlvenariaEstruturalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion
  async getAllAtividadeObra(request: GetAllAtividadeObraRequest): Promise<GetAllAtividadeObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/atividades-obra`, request);
      const response = handleAxiosResponse<GetAllAtividadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAtividadeObra(request: CreateAtividadeObraRequest): Promise<CreateAtividadeObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/atividades-obra/create`, request);
      const response = handleAxiosResponse<CreateAtividadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAtividadeObra(request: UpdateAtividadeObraRequest): Promise<UpdateAtividadeObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/atividades-obra/update`, request);
      const response = handleAxiosResponse<UpdateAtividadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAtividadeObra(request: DeleteAtividadeObraRequest): Promise<DeleteAtividadeObraResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/atividades-obra/delete/${request.idAtividadeObra}`);
      const response = handleAxiosResponse<DeleteAtividadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllEspecificidadeObra(request: GetAllEspecificidadeObraRequest): Promise<GetAllEspecificidadeObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/especificidades-obra`, request);
      const response = handleAxiosResponse<GetAllEspecificidadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createEspecificidadeObra(request: CreateEspecificidadeObraRequest): Promise<CreateEspecificidadeObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/especificidades-obra/create`, request);
      const response = handleAxiosResponse<CreateEspecificidadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateEspecificidadeObra(request: UpdateEspecificidadeObraRequest): Promise<UpdateEspecificidadeObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/especificidades-obra/update`, request);
      const response = handleAxiosResponse<UpdateEspecificidadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteEspecificidadeObra(request: DeleteEspecificidadeObraRequest): Promise<DeleteEspecificidadeObraResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/especificidades-obra/delete/${request.idEspecificidadeObra}`);
      const response = handleAxiosResponse<DeleteEspecificidadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllIndicadorObra(request: GetAllIndicadorObraRequest): Promise<GetAllIndicadorObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/indicadores-obra`, request);
      const response = handleAxiosResponse<GetAllIndicadorObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createIndicadorObra(request: CreateIndicadorObraRequest): Promise<CreateIndicadorObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/indicadores-obra/create`, request);
      const response = handleAxiosResponse<CreateIndicadorObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateIndicadorObra(request: UpdateIndicadorObraRequest): Promise<UpdateIndicadorObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/indicadores-obra/update`, request);
      const response = handleAxiosResponse<UpdateIndicadorObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteIndicadorObra(request: DeleteIndicadorObraRequest): Promise<DeleteIndicadorObraResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/indicadores-obra/delete/${request.idObraIndicador}`);
      const response = handleAxiosResponse<DeleteIndicadorObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllObraArquivo(request: GetAllObraArquivoRequest): Promise<GetAllObraArquivoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/documentos-obra`, request);
      const response = handleAxiosResponse<GetAllObraArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createObraArquivo(request: CreateObraArquivoRequest): Promise<CreateObraArquivoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/documentos-obra/create`, request);
      const response = handleAxiosResponse<CreateObraArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateObraArquivo(request: UpdateObraArquivoRequest): Promise<UpdateObraArquivoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/documentos-obra/update`, request);
      const response = handleAxiosResponse<UpdateObraArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObraArquivo(request: DeleteObraArquivoRequest): Promise<DeleteObraArquivoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/documentos-obra/delete/${request.idObraArquivo}`);
      const response = handleAxiosResponse<DeleteObraArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllObraInformacoes(request: GetAllObraInformacoesRequest): Promise<GetAllObraInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/informacoes-obra`, request);
      const response = handleAxiosResponse<GetAllObraInformacoesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createObraInformacoes(request: CreateObraInformacoesRequest): Promise<CreateObraInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/informacoes-obra/create`, request);
      const response = handleAxiosResponse<CreateObraInformacoesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateObraInformacoes(request: UpdateObraInformacoesRequest): Promise<UpdateObraInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/informacoes-obra/update`, request);
      const response = handleAxiosResponse<UpdateObraInformacoesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObraInformacoes(request: DeleteObraInformacoesRequest): Promise<DeleteObraInformacoesResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/informacoes-obra/delete/${request.idObraInformacoes}`);
      const response = handleAxiosResponse<DeleteObraInformacoesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMapaConcretagemFiltro(request: GetMapaConcretagemFiltroRequest): Promise<GetMapaConcretagemFiltroResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/mapa-concretagem/filtros`);
      const response = handleAxiosResponse<GetMapaConcretagemFiltroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async saveMapaConcretagemFiltro(request: SaveMapaConcretagemFiltroRequest): Promise<SaveMapaConcretagemFiltroResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/mapa-concretagem/filtros/save`, request);
      const response = handleAxiosResponse<SaveMapaConcretagemFiltroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraHeaderInfo(request: GetObraHeaderInfoRequest): Promise<GetObraHeaderInfoResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/header-info/${request.idObra}`);
      const response = handleAxiosResponse<GetObraHeaderInfoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async sendEmail(request: SendEmailRequest): Promise<SendEmailResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/plano-qualidade-obra/mail/send`, request);
      const response = handleAxiosResponse<SaveMapaConcretagemFiltroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getAllMapaConcretagem(request: GetAllMapaConcretagemRequest): Promise<GetAllMapaConcretagemResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/mapa-concretagens`, request);
      const response = handleAxiosResponse<GetAllMapaConcretagemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMapaConcretagemById(request: GetMapaConcretagemByIdRequest): Promise<GetMapaConcretagemByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/mapa-concretagens/${request.idMapaConcretagem}`);
      const response = handleAxiosResponse<GetMapaConcretagemByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createMapaConcretagem(request: CreateMapaConcretagemRequest): Promise<CreateMapaConcretagemResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/obras/mapa-concretagens/create`, formData, options);
      const response = handleAxiosResponse<CreateMapaConcretagemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateMapaConcretagem(request: UpdateMapaConcretagemRequest): Promise<UpdateMapaConcretagemResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/obras/mapa-concretagens/update`, formData, options);
      const response = handleAxiosResponse<UpdateMapaConcretagemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteMapaConcretagem(request: DeleteMapaConcretagemRequest): Promise<DeleteMapaConcretagemResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/mapa-concretagens/delete/${request.idMapaConcretagem}`);
      const response = handleAxiosResponse<DeleteMapaConcretagemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyMapaConcretagem(request: CopyMapaConcretagemRequest): Promise<CopyMapaConcretagemResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/mapa-concretagens/copy`, request);
      const response = handleAxiosResponse<DeleteMapaConcretagemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllObraAreaChecklist(request: GetAllObraAreaChecklistRequest): Promise<GetAllObraAreaChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists`, request);
      const response = handleAxiosResponse<GetAllObraAreaChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createObraAreaChecklist(request: CreateObraAreaChecklistRequest): Promise<CreateObraAreaChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/create`, request);
      const response = handleAxiosResponse<CreateObraAreaChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createObraAreaEmpreendimentoChecklist(request: CreateObraAreaEmpreendimentoChecklistRequest): Promise<CreateObraAreaEmpreendimentoChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/empreendimento/create`, request);
      const response = handleAxiosResponse<CreateObraAreaEmpreendimentoChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region Obra Gestão de Resíduos
  async getObrasGestaoResiduosList(request: GetAllObrasGestaoDeResiduosRequest): Promise<GetAllObrasGestaoDeResiduosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obras-gestaoderesiduos/lista`, request);
      const response = handleAxiosResponse<GetAllObrasGestaoDeResiduosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateObraAreaChecklist(request: UpdateObraAreaChecklistRequest): Promise<UpdateObraAreaChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/update`, request);
      const response = handleAxiosResponse<UpdateObraAreaChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async postGestaoResiduosCreate(request: CreateObrasGestaoDeResiduosRequest): Promise<number> {
    try {
      const result = await axiosInstance({}).post(`/obras/obras-gestaoderesiduos/create`, request);
      const response = handleAxiosResponse<number>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObraAreaChecklist(request: DeleteObraAreaChecklistRequest): Promise<DeleteObraAreaChecklistResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/area-checklists/delete/${request.idObraAreaChecklist}`);
      const response = handleAxiosResponse<DeleteObraAreaChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getByIdGestaoResiduos(request: { id: number }): Promise<GetByidObrasGestaoDeResiduosResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/obras-gestaoderesiduos/GetById/${request.id}`);
      const response = handleAxiosResponse<GetByidObrasGestaoDeResiduosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteLoteObraAreaChecklist(request: DeleteLoteObraAreaChecklistRequest): Promise<DeleteLoteObraAreaChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/delete/lote`, request);
      const response = handleAxiosResponse<DeleteLoteObraAreaChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async putGestaoResiduosUpdate(request: UpdateObrasGestaoDeResiduosRequest): Promise<void> {
    try {
      await axiosInstance({}).post(`/obras/obras-gestaoderesiduos/update`, request);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getStatInformationByIdObra(request: GetStatInformationByIdObraRequest): Promise<GetStatInformationByIdObraResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/area-checklists/${request.idObra}/stats`);
      const response = handleAxiosResponse<GetStatInformationByIdObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAreaChecklistServicos(request: CreateAreaChecklistServicosRequest): Promise<CreateAreaChecklistServicosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/servicos/create`, request);
      const response = handleAxiosResponse<CreateAreaChecklistServicosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAreaChecklistServicos(request: DeleteAreaChecklistServicosRequest): Promise<DeleteAreaChecklistServicosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/servicos/delete`, request);
      const response = handleAxiosResponse<DeleteAreaChecklistServicosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyObraAreaChecklist(request: CopyObraAreaChecklistRequest): Promise<CopyObraAreaChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/copy`, request);
      const response = handleAxiosResponse<CopyObraAreaChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteGestaoResiduos(request: { id: number }): Promise<void> {
    try {
      await axiosInstance({}).delete(`/obras/obras-gestaoderesiduos/delete/${request.id}`);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }
  //#endregion

  //#region ControleMateriais

  async getAllControleMateriaisList(request: GetAllControleMateriaisRequest): Promise<GetAllControleMateriaisResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/controlematerial/list`, request);
      const response = handleAxiosResponse<GetAllControleMateriaisResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async postControleMateriaisCreate(request: CreateControleMateriaisRequest): Promise<number> {
    try {
      const result = await axiosInstance({}).post(`/obras/controlematerial/create`, request);
      const response = handleAxiosResponse<number>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getByIdControleMateriais(request: { id: number }): Promise<GetControleMateriaisByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/controlematerial/getbyid/${request.id}`);
      const response = handleAxiosResponse<GetControleMateriaisByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControleMateriais(request: UpdateControleMateriaisRequest): Promise<void> {
    try {
      await axiosInstance({}).post(`/obras/controlematerial/update`, request);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControleMateriais(request: { id: number }): Promise<void> {
    try {
      const result = await axiosInstance({}).delete(`/obras/controlematerial/delete/${request.id}`);
      handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region ControleServicos

  async getAllControleServicosList(request: GetAllControleServicosRequest): Promise<GetAllControleServicosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/controleservicos/list`, request);
      const response = handleAxiosResponse<GetAllControleServicosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async postControleServicosCreate(request: CreateControleServicosRequest): Promise<number> {
    try {
      const result = await axiosInstance({}).post(`/obras/controleservicos/create`, request);
      const response = handleAxiosResponse<number>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getByIdControleServicos(request: { id: number }): Promise<GetControleServicosByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/controleservicos/getbyid/${request.id}`);
      const response = handleAxiosResponse<GetControleServicosByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControleServicos(request: UpdateControleServicosRequest): Promise<void> {
    try {
      await axiosInstance({}).post(`/obras/controleservicos/update`, request);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControleServicos(request: { id: number }): Promise<void> {
    try {
      await axiosInstance({}).delete(`/obras/controleservicos/delete/${request.id}`);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  async getObraAreaChecklistHeader(request: GetObraAreaChecklistHeaderRequest): Promise<GetObraAreaChecklistHeaderResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/area-checklists/header`, request);
      const response = handleAxiosResponse<GetObraAreaChecklistHeaderResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllObraChecklistServico(request: GetAllObraChecklistServicoRequest): Promise<GetAllObraChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servicos`, request);
      const response = handleAxiosResponse<GetAllObraChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region ObrasMateriaisControlados

  async getAllObrasMateriaisControladosList(
    request: GetAllObrasMateriaisControladosRequest,
  ): Promise<GetAllObrasMateriaisControladosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obrascontrolematerial/list`, request);
      const response = handleAxiosResponse<GetAllObrasMateriaisControladosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createObraChecklistServicos(request: CreateObraChecklistServicosRequest): Promise<CreateObraChecklistServicosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servicos/create`, request);
      const response = handleAxiosResponse<CreateObraChecklistServicosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObraMateriaisControlados(request: { id: number }): Promise<void> {
    try {
      await axiosInstance({}).delete(`/obras/obrascontrolematerial/delete/${request.id}`);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async obrasMateriaisControladosDropdown(request: { id: number }): Promise<GetObraMateriaisControladosDropDown[]> {
    try {
      const result = await axiosInstance({}).get(`/obras/obrascontrolematerial/Dropdow/${request.id}`);
      const response = handleAxiosResponse<GetObraMateriaisControladosDropDown[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteObraChecklistServicos(request: DeleteObraChecklistServicosRequest): Promise<DeleteObraChecklistServicosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servicos/delete`, request);
      const response = handleAxiosResponse<DeleteObraChecklistServicosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async postObraMateriaisControladosCreate(request: CreateObraMateriaisControladosRequest): Promise<number> {
    try {
      const result = await axiosInstance({}).post(`/obras/obrascontrolematerial/create`, request);
      const response = handleAxiosResponse<number>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region ObrasServicosControlados

  async getAllObrasServicosControladosList(
    request: GetAllObrasServicosControladosRequest,
  ): Promise<GetAllObrasServicosControladosResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obrascontroleservico/list`, request);
      const response = handleAxiosResponse<GetAllObrasServicosControladosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getObraChecklistServicoHeader(request: GetObraChecklistServicoHeaderRequest): Promise<GetObraChecklistServicoHeaderResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servicos/header`, request);
      const response = handleAxiosResponse<GetObraChecklistServicoHeaderResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteObraServicosControlados(request: { id: number }): Promise<void> {
    try {
      await axiosInstance({}).delete(`/obras/obrascontroleservico/delete/${request.id}`);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async obrasServicosControladosDropdown(request: { id: number }): Promise<GetObraServicosControladosDropDown[]> {
    try {
      const result = await axiosInstance({}).get(`/obras/obrascontroleservico/dropdow/${request.id}`);
      const response = handleAxiosResponse<GetObraServicosControladosDropDown[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAllInspecaoObra(request: GetAllInspecaoObraRequest): Promise<GetAllInspecaoObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra`, request);
      const response = handleAxiosResponse<GetAllInspecaoObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async postObraServicosControladosCreate(request: CreateObraServicosControladosRequest): Promise<number> {
    try {
      const result = await axiosInstance({}).post(`/obras/obrascontroleservico/create`, request);
      const response = handleAxiosResponse<number>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraChecklistServicoStatisticas(
    request: GetObraChecklistServicoStatisticasRequest,
  ): Promise<GetObraChecklistServicoStatisticasResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servicos/estatisticas`, request);
      const response = handleAxiosResponse<GetObraChecklistServicoStatisticasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateStatusObraChecklistServico(
    request: UpdateStatusObraChecklistServicoRequest,
  ): Promise<UpdateStatusObraChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servicos/update/status`, request);
      const response = handleAxiosResponse<UpdateStatusObraChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateMetaObraChecklistServico(request: UpdateMetaObraChecklistServicoRequest): Promise<UpdateMetaObraChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servicos/update/meta`, request);
      const response = handleAxiosResponse<UpdateMetaObraChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateInspecaoObraAprovacaoLote(request: UpdateInspecaoObraAprovacaoLoteRequest): Promise<UpdateInspecaoObraAprovacaoLoteResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/update/aprovacao-lote`, request);
      const response = handleAxiosResponse<UpdateInspecaoObraAprovacaoLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getObraChecklistServicoCampos(request: GetObraChecklistServicoCamposRequest): Promise<GetObraChecklistServicoCamposResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/obra-checklist-servicos/${request.idObraChecklistServico}/fields`);
      const response = handleAxiosResponse<GetObraChecklistServicoCamposResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createInspecaoObra(request: CreateInspecaoObraRequest): Promise<CreateInspecaoObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/create`, request);
      const response = handleAxiosResponse<CreateInspecaoObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  async updateInspecaoObra(request: UpdateInspecaoObraRequest): Promise<UpdateInspecaoObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/update`, request);
      const response = handleAxiosResponse<CreateInspecaoObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllAtributosObrasCadastroList(): Promise<GetAllAtributosObrasCadastroResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/atributosobras/list`);
      const response = handleAxiosResponse<GetAllAtributosObrasCadastroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteInspecaoObra(request: DeleteInspecaoObraRequest): Promise<DeleteInspecaoObraResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/inspecoes-obra/${request.idInspecaoObra}/delete`);
      const response = handleAxiosResponse<CreateInspecaoObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyInspecaoObra(request: CopyInspecaoObraRequest): Promise<CopyInspecaoObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/copy`, request);
      const response = handleAxiosResponse<CopyInspecaoObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getInspecaoObraById(request: GetInspecaoObraByIdRequest): Promise<GetInspecaoObraByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/inspecoes-obra/${request.idInspecaoObra}`);
      const response = handleAxiosResponse<GetInspecaoObraByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllInspecaoObraItem({ idInspecaoObra, ...request }: GetAllInspecaoObraItemRequest): Promise<GetAllInspecaoObraItemResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/${idInspecaoObra}/items`, request);
      const response = handleAxiosResponse<GetAllInspecaoObraItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllExecutadoPor({ idInspecaoObra, ...request }: GetAllExecutadoPorRequest): Promise<GetAllExecutadoPorResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/${idInspecaoObra}/executado-por`, request);
      const response = handleAxiosResponse<GetAllExecutadoPorResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllInspecaoObraOcorrencia({
    idInspecaoObra,
    ...request
  }: GetAllInspecaoObraOcorrenciaRequest): Promise<GetAllInspecaoObraOcorrenciaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/${idInspecaoObra}/ocorrencias`, request);
      const response = handleAxiosResponse<GetAllInspecaoObraOcorrenciaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createInspecaoObraOcorrencia({
    idInspecaoObra,
    ...request
  }: CreateInspecaoObraOcorrenciaRequest): Promise<CreateInspecaoObraOcorrenciaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/${idInspecaoObra}/ocorrencias/create`, request);
      const response = handleAxiosResponse<CreateInspecaoObraOcorrenciaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateInspecaoObraOcorrencia({
    idInspecaoObra,
    ...request
  }: UpdateInspecaoObraOcorrenciaRequest): Promise<UpdateInspecaoObraOcorrenciaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/${idInspecaoObra}/ocorrencias/update`, request);
      const response = handleAxiosResponse<UpdateInspecaoObraOcorrenciaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteInspecaoObraOcorrencia({
    idInspecaoObra,
    idInformacoesInspecaoObra,
    ...request
  }: DeleteInspecaoObraOcorrenciaRequest): Promise<DeleteInspecaoObraOcorrenciaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/obras/inspecoes-obra/${idInspecaoObra}/ocorrencias/${idInformacoesInspecaoObra}/delete`,
        request,
      );
      const response = handleAxiosResponse<DeleteInspecaoObraOcorrenciaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createInspecaoObraExecutadoPor({
    idInspecaoObra,
    ...request
  }: CreateInspecaoObraExecutadoPorRequest): Promise<CreateInspecaoObraExecutadoPorResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/${idInspecaoObra}/executado-por/create`, request);
      const response = handleAxiosResponse<CreateInspecaoObraExecutadoPorResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteInspecaoObraExecutadoPor({
    idInspecaoObra,
    idExecutadoPor,
    ...request
  }: DeleteInspecaoObraExecutadoPorRequest): Promise<DeleteInspecaoObraExecutadoPorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/obras/inspecoes-obra/${idInspecaoObra}/executado-por/${idExecutadoPor}/delete`,
        request,
      );
      const response = handleAxiosResponse<DeleteInspecaoObraExecutadoPorResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateInspecaoObraWithValidation(
    request: UpdateInspecaoObraWithValidationRequest,
  ): Promise<UpdateInspecaoObraWithValidationResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/update-with-validation`, formData, config);
      const response = handleAxiosResponse<DeleteInspecaoObraExecutadoPorResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getInspecaoObraImage({ idInspecaoObra, imagePosition }: GetInspecaoObraImageRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/obras/inspecoes-obra/${idInspecaoObra}/image/${imagePosition}/download`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllChecklistServico(request: GetAllChecklistServicoRequest): Promise<GetAllChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servicos`, request);
      const response = handleAxiosResponse<GetAllChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createChecklistServico(request: CreateChecklistServicoRequest): Promise<CreateChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servicos/create`, request);
      const response = handleAxiosResponse<CreateChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateChecklistServico(request: UpdateChecklistServicoRequest): Promise<UpdateChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servicos/update`, request);
      const response = handleAxiosResponse<UpdateChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteChecklistServico({ idChecklistServico }: DeleteChecklistServicoRequest): Promise<DeleteChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/checklist-servicos/${idChecklistServico}/delete`);
      const response = handleAxiosResponse<DeleteChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyChecklistServico({ idChecklistServico, ...request }: CopyChecklistServicoRequest): Promise<CopyChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servicos/${idChecklistServico}/copy`, request);
      const response = handleAxiosResponse<CopyChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getChecklistServicoById({ idChecklistServico }: GetChecklistServicoByIdRequest): Promise<GetChecklistServicoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/checklist-servicos/${idChecklistServico}`);
      const response = handleAxiosResponse<GetChecklistServicoByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllItemChecklistServico(request: GetAllItemChecklistServicoRequest): Promise<GetAllItemChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/itens-checklist-servico`, request);
      const response = handleAxiosResponse<GetAllItemChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createItemChecklistServico(request: CreateItemChecklistServicoRequest): Promise<CreateItemChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/itens-checklist-servico/create`, request);
      const response = handleAxiosResponse<CreateItemChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateItemChecklistServico(request: UpdateItemChecklistServicoRequest): Promise<UpdateItemChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/itens-checklist-servico/update`, request);
      const response = handleAxiosResponse<UpdateItemChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteItemChecklistServico({
    idItemChecklistServico,
  }: DeleteItemChecklistServicoRequest): Promise<DeleteItemChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/itens-checklist-servico/${idItemChecklistServico}/delete`);
      const response = handleAxiosResponse<DeleteItemChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getEstatisticasChecklistServico({
    idChecklistServico,
  }: GetEstatisticasChecklistServicoRequest): Promise<GetEstatisticasChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/statisticas-checklist-servico/${idChecklistServico}`);
      const response = handleAxiosResponse<GetEstatisticasChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region AtributosObrasCadastro

  async updateAtributosObrasCadastro(request: UpdateAtributosObrasCadastroRequest): Promise<void> {
    try {
      await axiosInstance({}).post(`/obras/atributosobras/update`, request);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region --- CONTROLE DE RESÍDUOS ---

  async getAllControleResiduo(request: GetAllControleResiduoRequest): Promise<GetAllControleResiduoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/residuos`, request);
      const response = handleAxiosResponse<GetAllControleResiduoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async downloadObraDocumento({ idObraArquivo }: DownloadObraDocumentoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/obras/documentos-obra/${idObraArquivo}/download`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getControleResiduoById(request: GetControleResiduoByIdRequest): Promise<GetControleResiduoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/sustentabilidade/residuos/${request.id}`);
      const response = handleAxiosResponse<GetControleResiduoByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createControleResiduo(request: CreateControleResiduoRequest): Promise<CreateControleResiduoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/residuos/create`, request);
      const response = handleAxiosResponse<CreateControleResiduoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControleResiduo(request: UpdateControleResiduoRequest): Promise<UpdateControleResiduoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/residuos/update`, request);
      const response = handleAxiosResponse<UpdateControleResiduoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControleResiduo(request: DeleteControleResiduoRequest): Promise<DeleteControleResiduoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/sustentabilidade/residuos/delete/${request.id}`);
      const response = handleAxiosResponse<DeleteControleResiduoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  // #region --- CONTROLE DE ENERGIA ---

  async getAllControleEnergia(request: GetAllControleEnergiaRequest): Promise<GetAllControleEnergiaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/energia`, request);
      const response = handleAxiosResponse<GetAllControleEnergiaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getControleEnergiaById(request: GetControleEnergiaByIdRequest): Promise<GetControleEnergiaByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/sustentabilidade/energia/${request.id}`);
      const response = handleAxiosResponse<GetControleEnergiaByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createControleEnergia(request: CreateControleEnergiaRequest): Promise<CreateControleEnergiaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/energia/create`, request);
      const response = handleAxiosResponse<CreateControleEnergiaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControleEnergia(request: UpdateControleEnergiaRequest): Promise<UpdateControleEnergiaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/energia/update`, request);
      const response = handleAxiosResponse<UpdateControleEnergiaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControleEnergia(request: DeleteControleEnergiaRequest): Promise<DeleteControleEnergiaResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/sustentabilidade/energia/delete/${request.id}`);
      const response = handleAxiosResponse<DeleteControleEnergiaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  // #region --- CONTROLE DE ÁGUA ---

  async getAllControleAgua(request: GetAllControleAguaRequest): Promise<GetAllControleAguaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/agua`, request);
      const response = handleAxiosResponse<GetAllControleAguaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getControleAguaById(request: GetControleAguaByIdRequest): Promise<GetControleAguaByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/sustentabilidade/agua/${request.id}`);
      const response = handleAxiosResponse<GetControleAguaByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createControleAgua(request: CreateControleAguaRequest): Promise<CreateControleAguaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/agua/create`, request);
      const response = handleAxiosResponse<CreateControleAguaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControleAgua(request: UpdateControleAguaRequest): Promise<UpdateControleAguaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/sustentabilidade/agua/update`, request);
      const response = handleAxiosResponse<UpdateControleAguaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControleAgua(request: DeleteControleAguaRequest): Promise<DeleteControleAguaResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/sustentabilidade/agua/delete/${request.id}`);
      const response = handleAxiosResponse<DeleteControleAguaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion


  //#region MAQUINAS EQUIPAMENTOS (PÁGINA DE OBRA EQUIPAMENTO CRÍTICO)

  async getAllManutencaoEquipObra(request: GetAllManutencaoEquipObraRequest): Promise<GetAllManutencaoEquipObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/manutencao-equip-obra/all`, request);
      const response = handleAxiosResponse<GetAllManutencaoEquipObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async getManutencaoEquipObraById(request: GetManutencaoEquipObraByIdRequest): Promise<GetManutencaoEquipObraByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/manutencao-equip-obra/${request.idManutencaoEquipObra}`);
      const response = handleAxiosResponse<GetManutencaoEquipObraByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async createManutencaoEquipObra(request: CreateManutencaoEquipObraRequest): Promise<CreateManutencaoEquipObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/manutencao-equip-obra/create`, request);
      const response = handleAxiosResponse<CreateManutencaoEquipObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async updateManutencaoEquipObra(request: UpdateManutencaoEquipObraRequest): Promise<UpdateManutencaoEquipObraResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/manutencao-equip-obra/update`, request);
      const response = handleAxiosResponse<UpdateManutencaoEquipObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async deleteManutencaoEquipObra(idManutencaoEquipObra: number): Promise<void> {
    try {
      const result = await axiosInstance({}).delete(`/obras/manutencao-equip-obra/${idManutencaoEquipObra}/delete`);
      const response = handleAxiosResponse<void>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  //#endregion

  async getDashboardObrasInformation(request: GetDashboardObrasInformationRequest): Promise<GetDashboardObrasInformationResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/dashboard/information`);
      const response = handleAxiosResponse<GetDashboardObrasInformationResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getRestricoesPainelObra(request: GetRestricoesPainelObraRequest): Promise<GetRestricoesPainelObraResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/restricoes-painel`);
      const response = handleAxiosResponse<GetRestricoesPainelObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteSelectedItemChecklistServico(request: DeleteSelectedItemChecklistServicoRequest): Promise<DeleteSelectedItemChecklistServicoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/itens-checklist-servico/delete-all`, request);
      const response = handleAxiosResponse<DeleteSelectedItemChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async downloadMateriaisControladosById({ idMateriaisControlados }: DownloadMateriaisControladosByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({}).get(`/obras/materiais-controlados/${idMateriaisControlados}/download`, { responseType: 'blob' });
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async aprovacaoFinalMapaConcretagem({ idMapaConcretagem, ...request }: AprovacaoFinalMapaConcretagemRequest): Promise<AprovacaoFinalMapaConcretagemResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/mapa-concretagens/${idMapaConcretagem}/aprovacao-final`, request);
      const response = handleAxiosResponse<AprovacaoFinalMapaConcretagemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getIndicadoresServicosObras({ idObra, ...request }: GetIndicadoresServicosObrasRequest): Promise<GetIndicadoresServicosObrasResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/${idObra}/indicadores-servicos`, request);
      const response = handleAxiosResponse<GetIndicadoresServicosObrasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getChecklistServicosByIdObraDropDown({ idObra, idObraAreaChecklist, ...request }: GetChecklistServicosByIdObraDropDownRequest): Promise<GetChecklistServicosByIdObraDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico/${idObra}/area/${idObraAreaChecklist}/dropdown`, {
        ...request,
      });
      const response = handleAxiosResponse<GetChecklistServicosByIdObraDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async downloadAlvenariaEstrutura({ idAlvenariaObra, nroArquivo }: DownloadAlvenariaEstruturaRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/obras/alvenaria-estrutura/${idAlvenariaObra}/download/${nroArquivo}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }




  //#region ChecklistServicoAmbiente

  async getChecklistServicoAmbienteById(request: GetChecklistServicoAmbienteByIdRequest): Promise<GetChecklistServicoAmbienteByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/checklist-servico-ambiente/${request.idChecklistServicoAmbiente}`);
      const response = handleAxiosResponse<GetChecklistServicoAmbienteByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async downloadMapaConcretagemArquivo({
    idMapaConcretagem,
    nroArquivo,
  }: DownloadMapaConcretagemArquivoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/obras/mapa-concretagens/${idMapaConcretagem}/download/${nroArquivo}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async getAllChecklistServicoAmbientes(request: GetAllChecklistServicoAmbienteRequest): Promise<GetAllChecklistServicoAmbienteResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico-ambiente/all`, request);
      const response = handleAxiosResponse<GetAllChecklistServicoAmbienteResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };


  async downloadEquipamentoMedicaoArquivo({
    idEquipamentoMedicao,
    nroArquivo,
  }: DownloadEquipamentoMedicaoArquivoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/obras/equipamentomedicao/${idEquipamentoMedicao}/download/${nroArquivo}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async deleteChecklistServicoAmbienteById(idChecklistServicoAmbiente: number): Promise<void> {
    try {
      const result = await axiosInstance({}).get(`/obras/checklist-servico-ambiente/delete/${idChecklistServicoAmbiente}`);
      handleAxiosResponse<void>(result);
      return;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async createChecklistServicoAmbiente(request: CreateChecklistServicoAmbienteRequest): Promise<CreateChecklistServicoAmbienteResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico-ambiente/create`, request);
      const response = handleAxiosResponse<CreateChecklistServicoAmbienteResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async updateChecklistServicoAmbiente(request: UpdateChecklistServicoAmbienteRequest): Promise<UpdateChecklistServicoAmbienteResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico-ambiente/update`, request);
      const response = handleAxiosResponse<UpdateChecklistServicoAmbienteResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async copiaChecklistServicoAmbiente(request: CopyChecklistServicoAmbienteRequest): Promise<CopyChecklistServicoAmbienteResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico-ambiente/copy`, request);
      const response = handleAxiosResponse<CopyChecklistServicoAmbienteResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  //#endregion

  async getReinspecaoEmAbertoLista(request: GetReinspecaoEmAbertoListaRequest): Promise<GetReinspecaoEmAbertoListaResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/inspecoes-obra/reinspecao-em-aberto`, request);
      const response = handleAxiosResponse<GetReinspecaoEmAbertoListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async getObraChecklistServicoLiberacaoById({ idObraChecklistServico, idChecklistServico }: GetObraChecklistServicoLiberacaoByIdRequest): Promise<GetObraChecklistServicoLiberacaoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/obra-checklist-servico/${idObraChecklistServico}/liberacao/${idChecklistServico}`);
      return handleAxiosResponse<GetObraChecklistServicoLiberacaoByIdResponse>(result);
    } catch (error: unknown) {
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao buscar liberação do checklist de serviço!");
    }
  }

  async saveObraChecklistServicoLiberacao({ idObraChecklistServico, idChecklistServico, ...form }: SaveObraChecklistServicoLiberacaoRequest): Promise<void> {
    try {
      const result = await axiosInstance({}).post(`/obras/obra-checklist-servico/${idObraChecklistServico}/liberacao/${idChecklistServico}/save`, {
        ...form,
        dataLiberacao: form.dataLiberacao ? dayjs(form.dataLiberacao).format('YYYY-MM-DD') : null,
      });
      handleAxiosResponse(result);
    } catch (error: unknown) {
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao salvar liberação do checklist de serviço!");
    }
  }

  async getAllChecklistServicoLiberacao(
    request: GetAllChecklistServicoLiberacaoRequest,
  ): Promise<GetAllChecklistServicoLiberacaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico-liberacao`, request);
      const response = handleAxiosResponse<GetAllChecklistServicoLiberacaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getChecklistServicoLiberacaoById(
    {
      idChecklistServicoLiberacao,
    }: GetChecklistServicoLiberacaoByIdRequest,
  ): Promise<GetChecklistServicoLiberacaoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/obras/checklist-servico-liberacao/${idChecklistServicoLiberacao}`);
      const response = handleAxiosResponse<GetChecklistServicoLiberacaoByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createChecklistServicoLiberacao(
    request: CreateChecklistServicoLiberacaoRequest,
  ): Promise<CreateChecklistServicoLiberacaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico-liberacao/create`, request);
      const response = handleAxiosResponse<CreateChecklistServicoLiberacaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateChecklistServicoLiberacao(
    {
      idChecklistServicoLiberacao,
      ...request
    }: UpdateChecklistServicoLiberacaoRequest,
  ): Promise<UpdateChecklistServicoLiberacaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/obras/checklist-servico-liberacao/${idChecklistServicoLiberacao}/update`, request);
      const response = handleAxiosResponse<UpdateChecklistServicoLiberacaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteChecklistServicoLiberacao(
    {
      idChecklistServicoLiberacao,
    }: DeleteChecklistServicoLiberacaoRequest
  ): Promise<DeleteChecklistServicoLiberacaoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/obras/checklist-servico-liberacao/${idChecklistServicoLiberacao}/delete`);
      const response = handleAxiosResponse<DeleteChecklistServicoLiberacaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}



